import Vue from 'vue';

const promoActionRepository = {
    list: () => Vue.$axios.get('dishes')
        .then(({data}) => data, (error) => console.log(error)),
};

export default promoActionRepository;
